import { Theme } from '@mui/material';

const Alert = (theme: Theme) => {
  return {
  };
};

export default Alert;
